import AppsOutlinedIcon from '@mui/icons-material/AppsOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import type { SvgIconComponent } from '@mui/icons-material';
import type { EmbeddedApplicationPermissions } from '@/types/embeddedApplication';

const iconMap: Record<string, SvgIconComponent> = {
  search: SearchOutlinedIcon,
  notifications: NotificationsNoneOutlinedIcon,
  timeline: TimelineOutlinedIcon,
  description: DescriptionOutlinedIcon,
  apps: AppsOutlinedIcon,
  folder: FolderOutlinedIcon,
};

export function resolveEmbeddedIcon(icon?: string): SvgIconComponent {
  if (!icon) {
    return DescriptionOutlinedIcon;
  }

  const normalized = icon.toLowerCase().replace(/[^a-z0-9]/g, '');

  return iconMap[normalized] ?? iconMap[icon] ?? AppsOutlinedIcon;
}

export function isEmbeddedFeatureVisible(
  permissions: EmbeddedApplicationPermissions | undefined,
  userRoles: string[] = [],
): boolean {
  if (!permissions?.roles?.length) {
    return true;
  }

  return permissions.roles.some((role) => userRoles.includes(role));
}
